import { render } from "./DeviceCreateComponent.vue?vue&type=template&id=5faed587&scoped=true"
import script from "./DeviceCreateComponent.vue?vue&type=script&lang=js"
export * from "./DeviceCreateComponent.vue?vue&type=script&lang=js"

import "./DeviceCreateComponent.vue?vue&type=style&index=0&id=5faed587&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faed587"]])

export default __exports__